// extracted by mini-css-extract-plugin
export default {"title":"c7356730fd","inner_title":"b6d4c10873","charge_btn":"_260f883816"};